document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] #search-form-sidebar`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });


  const isCart = window.location.pathname === '/cart';

  const bssDiscountCode = document.querySelector(".bss-b2b-discount-code-wrapper");
  const btnCheckout = document.querySelector("#CheckOut");
  if (bssDiscountCode && btnCheckout) {
      btnCheckout.insertAdjacentElement("beforeBegin", bssDiscountCode); 
  }
});